import {EndorsementStatus} from "@/api-client";
import {ls} from "@/CultureService";

export default function translateEndorsementStatus(status: EndorsementStatus): string {
    switch (status) {
        case EndorsementStatus.Valid:
            return ls.Global_ValidityState_Valid;
        case EndorsementStatus.Suspended:
            return ls.Global_ValidityState_Suspended;
        case EndorsementStatus.Invalid:
            return ls.Global_ValidityState_Invalid;
        default:
            return status;
    }
}